import { ref } from 'vue'

export function useLayout() {
  const isMobileMenuOpen = ref(false)

  const toggleMobileMenu = () => {
    isMobileMenuOpen.value = !isMobileMenuOpen.value
  }

  return {
    isMobileMenuOpen,
    toggleMobileMenu
  }
}